var shared = require('./_shared')('keys')
  , uid    = require('./_uid');
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/core-js/library/modules/_shared-key.js
// module id = 152
// module chunks = 0